





















































































import { Component, Vue } from "vue-property-decorator";
import TextEditor from "@/components/TextEditor.vue";
import ExpressionEditor from "@/components/ExpressionEditor.vue";
import { getMathServerClient } from "@/store/modules/util";
import { EquivalencyType } from 'gradarius-client';


enum Equiv {
  yes = "yes",
  no = "no",
  dontknow = "dontknow"
}

@Component({
  components: { ExpressionEditor, TextEditor }
})
export default class EditorDemo extends Vue {
  equivalent = Equiv.dontknow;

  validate(): void {
    const ee = this.$refs.editor1 as ExpressionEditor;
    ee.validate();
  }
  async computeDerivative(): Promise<void> {
    const ee2 = this.$refs.editor2 as ExpressionEditor;
    const ee3 = this.$refs.editor3 as ExpressionEditor;
    const client = getMathServerClient();
    const grl = ee2.getGRL();
    if (grl) {
      try {
        const result = await client.compute(grl);
        try {
          const grl2 = await client.simplify(result.result);
          ee3.setGRL(grl2);
        } catch (e) {
          if (result.changesCount > 0) {
            ee3.setGRL(result.result);
          } else {
            alert("Sorry, can't compute this");
          }
        }
      } catch (e) {
        alert("Sorry, can't compute this");
      }
    }
  }
  async checkEquivalence(): Promise<void> {
    const ee4 = this.$refs.editor4 as ExpressionEditor;
    const ee5 = this.$refs.editor5 as ExpressionEditor;

    const client = getMathServerClient();
    let grl1 = ee4.getGRL();
    let grl2 = ee5.getGRL();

    if (grl1 && grl2) {
      try {
        grl1 = (await client.compute(grl1)).result;
        grl2 = (await client.compute(grl2)).result;
        const eq = await client.checkEquivalency(grl1, grl2, EquivalencyType.calculus);
        this.equivalent = eq ? Equiv.yes : Equiv.no;
      } catch (e) {
        alert("Sorry, can't compute equivalence");
      }
    }
  }

  showMobileKeyboard(): void {
    const ee = this.$refs.editor6 as ExpressionEditor;
    ee.showMobileKeyboard();
  }
}
